import React from 'react'
import ourServiceImg from '../../Assets/ourServiceImg.png'
import '../../Styles/ourService.css'
export default function OurServices() {
  return (
    <div className='services'>
        <div className="text">OUR SERVICES</div>
        <div className="contentSection">
            <div className="img">
                <img src={ourServiceImg} alt="image" />
            </div>
            <div className="content">
                <div className="contentHeading">DEVELOPING AND DESIGNING</div>
                <div className='container'>
                <div className="contentleft">
                    <div className="contentlefthead">Website Development:</div>
                    <div className="leftheadContent">
                        <div>Responsive and mobile-friendly design </div>
                        <div>E-commerce solutions </div>
                        <div>Content Management Systems (CMS)</div>
                        <div>Custom web applications</div>
                    </div>
                </div>
                <div className='border'></div>
                <div className="line"></div>
                <div className="contentRight">
                    <div className="contentRighthead">App Development:</div>
                    <div className="rightheadContent">
                        <div>Native and cross-platform app development </div>
                        <div>UI/UX design for optimal user interaction</div>
                        <div>Integration of advanced features and </div>
                        <div>functionalities</div>
                        <div>Rigorous testing for performance and security</div>
                    </div>
                </div>
                <div className='rightborder'></div>
            </div>
        </div>
        </div>
    </div>
  )
}
